/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ScanLeadsHealth from './ScanLeadsHealth';
import LeadsHealthMeter from './LeadsHealthMeter';
import LeadsHealthIssues from './LeadsHealthIssues';
import Statistics from './Statistics';
import WithCsportalAuth from '../../hooks/WithCsportalAuth';
import FaqWrapper from '../common/FaqWrapper';
import { getStatistics } from '../../api';
import { getProjectId, getSourceValue } from '../../lib/common';
import { useLocalStorage } from '../../hooks';

function ContractHealth({ id, statisticsData, statisticsLoading, apiKey, selectedFaqData, faqId }) {
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(5);
  const [analysisData, setAnalysisData] = useState({});
  const source = getSourceValue();
  const projectId = getProjectId();
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));

  useEffect(() => {
    const handleGetStatistics = async () => {
      setLoading(true);
      let timer;
      const progressInterval = setInterval(() => {
        setProgress((prevProgress) => {
          const newProgress = prevProgress + 5;
          if (newProgress === 95) {
            setLoading(false);
            clearInterval(progressInterval);
            clearTimeout(timer);
          }
          return newProgress;
        });
      }, 1000);
      if (id !== 'faq') {
        try {
          const params = {
            pid: projectId === 'csportal' ? selectedBusiness?.parentid || '' : selectedBusinessGenio?.parentId || '',
            city: projectId === 'csportal' ? selectedBusiness?.data_city || '' : selectedBusinessGenio?.city || '',
            type: 'healthCheck',
            source,
            projectId,
          };
          const res = await getStatistics(params);
          if (res && res.errorCode === 0) {
            setAnalysisData(res?.result || {});
          }
          setLoading(false);
          clearInterval(progressInterval);
        } catch (e) {
          console.log('error in getStatistics', e);
        }
      }

      return () => {
        clearInterval(progressInterval);
      };
    };
    handleGetStatistics();
  }, []);

  return (
    <>
      {id === 'faq' && statisticsLoading ? (
        <div style={{ height: '100px' }}>
          <div className="loader-div">
            <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
          </div>
        </div>
      ) : (
        id === 'faq' &&
        statisticsData &&
        statisticsData?.healthCheck !== 90 && (
          <Statistics
            selectedFaqData={selectedFaqData}
            statisticsData={(statisticsData && statisticsData?.data) || {}}
            apiKey={apiKey}
            faqId={faqId}
            projectId={projectId}
          />
        )
      )}
      {id !== 'faq' && (
        <>
          {loading ? (
            <ScanLeadsHealth progress={progress} id="contractHealth" />
          ) : (
            <>
              <LeadsHealthMeter healthCheckVal={analysisData && analysisData?.healthCheck} projectId={projectId} />
              <LeadsHealthIssues analysisData={(analysisData && analysisData?.data) || {}} projectId={projectId} />
            </>
          )}
        </>
      )}
    </>
  );
}

export default WithCsportalAuth(FaqWrapper(ContractHealth));

ContractHealth.propTypes = {
  id: PropTypes.string,
  statisticsData: PropTypes.object,
  statisticsLoading: PropTypes.bool,
  apiKey: PropTypes.string,
  selectedFaqData: PropTypes.object,
  faqId: PropTypes.number,
};

ContractHealth.defaultProps = {
  id: '',
  statisticsLoading: false,
  statisticsData: {},
  apiKey: '',
  selectedFaqData: {},
  faqId: null,
};
